import { StatusCirurgiaEnum } from '@/types/_'
import SolicitacaoClinicaApi, { ClinicaAtualizaAutorizacaoDaSolicitacao, ClinicaAtualizaDataAgendamentoDaSolicitacao, ClinicaAtualizaStatusDaSolicitacao, ClinicaFazCancelamentoDaSolicitacao } from '@/Apis/Agendamento/Services/SolicitacaoClinicaApi'
import { VuexModule, Module, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'SolicitacaoClinicaStore' })
export default class SolicitacaoClinicaStore extends VuexModule {
  @Action
  async atualizarAutorizacao(data: { solicitacaoId: string, data: ClinicaAtualizaAutorizacaoDaSolicitacao }) {
    return SolicitacaoClinicaApi.atualizarAutorizacao(data.solicitacaoId, data.data)
  }

  @Action
  async atualizarDataAgendamento(data: { solicitacaoId: string, data: ClinicaAtualizaDataAgendamentoDaSolicitacao }) {
    return SolicitacaoClinicaApi.atualizarDataAgendamento(data.solicitacaoId, data.data)
  }

  @Action
  async atualizarStatus(data: { solicitacaoId: string, data: ClinicaAtualizaStatusDaSolicitacao }) {
    return SolicitacaoClinicaApi.atualizarStatus(data.solicitacaoId, data.data)
  }

  @Action
  async cancelar(data: { solicitacaoId: string, data: ClinicaFazCancelamentoDaSolicitacao }) {
    return SolicitacaoClinicaApi.cancelar(data.solicitacaoId, data.data)
  }

  @Action
  async desfazerCancelamento(solicitacaoId: string) {
    return SolicitacaoClinicaApi.desfazerCancelamento(solicitacaoId)
  }

  @Action
  async marcarCirurgiaComoRealizada(solicitacaoId: string) {
    return SolicitacaoClinicaApi.atualizaStatusCirurgia(solicitacaoId, { statusCirurgia: StatusCirurgiaEnum.Realizada })
  }

  @Action
  async desmarcarCirurgiaComoRealizada(solicitacaoId: string) {
    return SolicitacaoClinicaApi.atualizaStatusCirurgia(solicitacaoId, { statusCirurgia: StatusCirurgiaEnum.NaoRealizada })
  }

  @Action
  async uploadAnexoOperadora(data: { solicitacaoId: string, data: { formData: FormData } }) {
    const { solicitacaoId } = data
    const { formData } = data.data
    return SolicitacaoClinicaApi.uploadAnexoOperadora(solicitacaoId, formData)
  }

  @Action
  async getAnexosOperadora(solicitacaoId: string) {
    return SolicitacaoClinicaApi.getAnexosOperadora(solicitacaoId)
  }
}
